import { COLOR } from '@george-labs.com/design-system';

export const creditCardContentBox = {
    showLockAndUnlockNavigation: true,
    showPayUpNavigation: true,
    cardMeter: {
        limitReachedColor: COLOR.UI_RED,
    },
    cardLegend: {
        defaultColor: COLOR.UI_RED,
    },
};
